export default "__VITE_ASSET__1ea394f3__"